/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

    var SOZO = {

        init: function(){
            // set as var as more efficient than calling "this" every time.
            var self = this;

            // the following functions run when the init is called. You should run functions that are required at initial load here, rather than being called later.
            self.runOnThisPage();
            self.swapsvg();
            self.tracking();
        },

        swapsvg: function() {
            if(!Modernizr.svg) {
                $('img[src*="svg"]').attr('src', function() {
                    return $(this).attr('src').replace('.svg', '.png');
                });
            }

        },

        // chosen: function(){
        //     $('.js-chosen-select').chosen();
        // },

        menu: function() {
          $('.primary-nav').MPMenu({
            bodyOverlay:  'body-overlay',
            menuLink:     'js-mobile-menu'
          });
        },

        tracking: function() {
            $('a').CWEventTracking();
        },

        hideReveals: function() {
            $('.js-cwhidereveal').CWHideReveal();
        },      

        tinyNav: function() {
            $(".js-tiny-nav").tinyNav();
        },

        sozoContentImage: function(){
            $('.primary-content .sozo-content img').each(function() {
                var thisElem = $(this);
                if ($(thisElem).parent().is( "p" )) {
                    $(thisElem).parent().addClass('image-parent');
                }
            });
        },

        circleListAnim: function() {
            $('.circle-step-list').each(function() {
                var thisElem = $(this);
                $(thisElem).appear({
                    once:true,
                    percentage:25,
                    appear:function(){
                        $(thisElem).removeClass('animate-me');
                        $(thisElem).intervalAssassin({
                              targetClass: '.animate-me',
                              interval: 250
                        });
                    }
                });
            });
        },        

        inlineSvgPcbImg: function(){
            $('.pcb-img-wrapper img.svg').each(function(){
                var $img = $(this);
                var imgID = $img.attr('id');
                var imgClass = $img.attr('class');
                var imgURL = $img.attr('src');

                jQuery.get(imgURL, function(data) {
                    // Get the SVG tag, ignore the rest
                    var $svg = jQuery(data).find('svg');

                    // Add replaced image's ID to the new SVG
                    if(typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if(typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass+' replaced-svg');
                    }

                    // Remove any invalid XML tags as per http://validator.w3.org
                    $svg = $svg.removeAttr('xmlns:a');

                    // Replace image with new SVG
                    $img.replaceWith($svg);

                }, 'xml');

            });
        },

        moveOnScroll: function(){
            var yOffset = 0;
            function moveOnScroll(moveObject){
                var x = $(this).scrollTop();
                if (yOffset > 0){
                    x -= yOffset;
                }
                var amount = 5;
                $(moveObject).css('-webkit-transform', 'translateY(' + parseInt(x/amount) + 'px)').css( '-moz-transform', 'translateY(' + parseInt(x/amount) + 'px)').css('transform', 'translateY(' + parseInt(x/amount) + 'px)').css;
            }
            // if (yOffset == 0){
            //     yOffset = $(window).scrollTop();
            // }
            $(window).scroll( function(){
                if ( !Modernizr.touchevents ) {
                    moveOnScroll('.js-move-on-scroll');
                }
            });
        },        

        lazyLoad: function(){
          $(".js-lazy").lazyload({
              effect : "fadeIn"
          });
        },
        
        /**
         * Screen width detection
         */
        screenWidth: function() {
            return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        },

        runOnThisPage: function(){
            var self = this;
            if($("body.home").length > 0) {
                // self.chosen();
            }
        },

        navShowHide: function(){

            /* @group show mobile nav on scroll up */

            var mainHeader = $('#header'),
                secondaryNavigation = $(''),
                //this applies only if secondary nav is below intro section
                belowNavHeroContent = $('.main-content'),
                headerHeight = mainHeader.height();
            
            //set scrolling variables
            var scrolling = false,
                previousTop = 0,
                currentTop = 0,
                scrollDelta = 10,
                scrollOffset = 150;

            mainHeader.on('click', '.nav-trigger', function(event){
                // open primary navigation on mobile
                event.preventDefault();
                mainHeader.toggleClass('nav-open');
            });

            $(window).on('scroll', function(){
                if( !scrolling ) {
                    scrolling = true;
                    (!window.requestAnimationFrame)
                        ? setTimeout(autoHideHeader, 250)
                        : requestAnimationFrame(autoHideHeader);
                }
            });

            $(window).on('resize', function(){
                headerHeight = mainHeader.height();
            });

            function autoHideHeader() {
                var currentTop = $(window).scrollTop();

                ( belowNavHeroContent.length > 0 ) 
                    ? checkStickyNavigation(currentTop) // secondary navigation below intro
                    : checkSimpleNavigation(currentTop);

                previousTop = currentTop;
                scrolling = false;
            }

            function checkSimpleNavigation(currentTop) {
                //there's no secondary nav or secondary nav is below primary nav
                if (previousTop - currentTop > scrollDelta) {
                    //if scrolling up...
                    mainHeader.removeClass('is-hidden');
                } else if( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
                    //if scrolling down...
                    mainHeader.addClass('is-hidden');
                }
            }

            function checkStickyNavigation(currentTop) {
                //secondary nav below intro section - sticky secondary nav
                var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();
                
                if (previousTop >= currentTop ) {
                    //if scrolling up... 
                    if( currentTop < secondaryNavOffsetTop ) {
                        //secondary nav is not fixed
                        mainHeader.removeClass('is-hidden');
                        secondaryNavigation.removeClass('fixed slide-up');
                        belowNavHeroContent.removeClass('secondary-nav-fixed');
                    } else if( previousTop - currentTop > scrollDelta ) {
                        //secondary nav is fixed
                        mainHeader.removeClass('is-hidden');
                        secondaryNavigation.removeClass('slide-up').addClass('fixed'); 
                        belowNavHeroContent.addClass('secondary-nav-fixed');
                    }
                    
                } else {
                    //if scrolling down...  
                    if( currentTop > secondaryNavOffsetTop + scrollOffset ) {
                        //hide primary nav
                        mainHeader.addClass('is-hidden');
                        secondaryNavigation.addClass('fixed slide-up');
                        belowNavHeroContent.addClass('secondary-nav-fixed');
                    } else if( currentTop > secondaryNavOffsetTop ) {
                        //once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset 
                        mainHeader.removeClass('is-hidden');
                        secondaryNavigation.addClass('fixed').removeClass('slide-up');
                        belowNavHeroContent.addClass('secondary-nav-fixed');
                    }

                }
            }

            /* @end */    
        },        

        /**
         * Debug code
         */
        debug: function(message) {
            if (this.debugStatus && typeof window.console !== 'undefined' && typeof window.console.debug !== 'undefined') {
                window.console.debug(message);
            }
        }

    };

    //runs all functions in the SOZO object
    SOZO.init();
    SOZO.menu();
    SOZO.hideReveals();
    SOZO.moveOnScroll();
    SOZO.tinyNav();
    SOZO.sozoContentImage();
    SOZO.inlineSvgPcbImg();
    SOZO.circleListAnim();
    SOZO.navShowHide();
  // SOZO.fancyPopup();
  // SOZO.fitVids();
  // SOZO.lazyLoad();

})(jQuery); // Fully reference jQuery after this point.
